module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.metric != null) ? _c('span', {
    staticClass: "error-badge badge pull-right",
    class: _vm.item.badgeColor || _vm.item.color
  }, [_vm._v("\n  " + _vm._s(_vm.item.metric) + " " + _vm._s(_vm.units) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ab7880","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/ErrorBadge.vue
// module id = 209
// module chunks = 5